export const facebookData = [
  {
    text: 'PR TIMES STORY',
    href: 'https://www.facebook.com/STORYBYPRTIMES/',
    color: '#000000',
  },
  {
    text: 'PR TIMES TV',
    href: 'https://www.facebook.com/prtimes.tv',
    color: '#294C7A',
  },
  {
    text: 'テクノロジー',
    href: 'https://www.facebook.com/prtimes.tech',
    color: '#585858',
  },
  {
    text: 'アプリケーション',
    href: 'https://www.facebook.com/PR-TIMES-%E3%82%A2%E3%83%97%E3%83%AA-432374826901950',
    color: '#e30f0f',
  },
  {
    text: 'スタートアップ',
    href: 'https://www.facebook.com/prtimes.startup',
    color: '#8791b5',
  },
  {
    text: 'エンタメ',
    href: 'https://www.facebook.com/prtimes.entertainment',
    color: '#edc81e',
  },
  {
    text: 'ビューティー',
    href: 'https://www.facebook.com/prtimes.beauty',
    color: '#f292b8',
  },
  {
    text: 'ファッション',
    href: 'https://www.facebook.com/prtimes.fashion',
    color: '#ed7014',
  },
  {
    text: 'ライフスタイル',
    href: 'https://www.facebook.com/prtimes.lifestyle',
    color: '#ed7014',
  },
  {
    text: 'トラベル',
    href: 'https://www.facebook.com/prtimes.travel',
    color: '#73c150',
  },
  {
    text: 'グルメ',
    href: 'https://www.facebook.com/prtimes.gourmet',
    color: '#ee6760',
  },
  {
    text: 'ゲーム',
    href: 'https://www.facebook.com/PR-TIMES-%E3%82%B2%E3%83%BC%E3%83%A0-724044057618274',
    color: '#8a83d0',
  },
  {
    text: 'スポーツ',
    href: 'https://www.facebook.com/PR-TIMES-%E3%82%B9%E3%83%9D%E3%83%BC%E3%83%84-513253112109063',
    color: '#1d8db9',
  },
  {
    text: 'ビデオ',
    href: 'https://www.facebook.com/prtimes.video',
    color: '#ff8985',
  },
  {
    text: 'ビジネス',
    href: 'https://www.facebook.com/prtimes.business',
    color: '#4775b4',
  },
  {
    text: 'マーケティング',
    href: 'https://www.facebook.com/prtimes.marketing',
    color: '#6a7591',
  },
];
